import React, { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { fetchDeliverySlots } from "@/lib/api";

/** Day + time-slot picker for delivery. Days/slots come from the admin settings; past or too-soon slots are hidden. */
export function DeliveryPicker({ value, onChange }: { value: { date?: string; slot?: string }; onChange: (v: { date?: string; slot?: string }) => void }) {
  const { t, locale } = useI18n();
  const [days, setDays] = useState<Array<{ date: string; slots: string[] }> | null>(null);

  useEffect(() => {
    fetchDeliverySlots()
      .then((r) => {
        setDays(r.days);
        if (!value.date && r.days[0]) onChange({ date: r.days[0].date, slot: undefined });
      })
      .catch(() => setDays([]));
  }, []);

  if (!days || days.length === 0) return null;
  const fmt = (d: string) =>
    new Intl.DateTimeFormat(locale === "en" ? "en-GB" : "ru-RU", { weekday: "short", day: "numeric", month: "short" }).format(new Date(`${d}T12:00:00+05:00`));
  const current = days.find((d) => d.date === value.date) ?? days[0];

  return (
    <div>
      <div className="section-heading">
        <span className="diamond" />
        {t("delivery.when")}
      </div>
      <div className="segmented" style={{ marginBottom: 12 }}>
        {days.map((d) => (
          <button key={d.date} className="chip" data-active={d.date === current.date} onClick={() => onChange({ date: d.date, slot: undefined })}>
            {fmt(d.date)}
          </button>
        ))}
      </div>
      <div className="slots">
        {current.slots.map((s) => (
          <button key={s} className="slot" data-active={value.slot === s && value.date === current.date} onClick={() => onChange({ date: current.date, slot: s })}>
            {s}
          </button>
        ))}
      </div>
      <p className="hint-line" style={{ marginBottom: 18 }}>
        {value.slot ? t("delivery.chosen", { slot: value.slot }) : t("delivery.pickSlot")}
      </p>
    </div>
  );
}
